import Accordion from './accordion'

import '../scss/base_page.scss'

class Page {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[CC+ page online]')

      const accordion = new Accordion()
    })
  }
}

export default new Page()
